import { atom } from 'recoil';

export const isTruckServiceModalOpenAtom = atom<boolean>({
  key: 'isTruckServiceModalOpenAtom',
  default: false,
});
